import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components/macro';
import ReactGA from 'react-ga';
import { useScrollPosition } from '../hooks/useScrollPosition';

// NOTE: This Component use Bulma Frameworks as base stylings.

export interface FixedBottomButtonProps {
  className?: string;
  href?: string;
}

const Root = styled.nav`
  .container {
    justify-content: flex-end;
    // For iPhoneX
    padding-bottom: env(safe-area-inset-bottom);
  }
  .navbar-item {
    padding: 10px;
  }
  .column:first-child {
    padding-right: 0;
  }
  .button {
    height: 44px;
  }
`;

export function FixedBottomButton(props: FixedBottomButtonProps) {
  const { y } = useScrollPosition();
  return (
    <Root
      className={classNames('navbar is-fixed-bottom', props.className, {
        'has-shadow': y > 10,
      })}
    >
      <div className="container is-fullhd">
        <div className="navbar-item">
          <div className="columns is-mobile">
            <p className="column">
              <a
                className="button is-primary is-fullwidth is-line is-medium has-text-weight-bold is-size-6-mobile"
                href="https://line.me/R/ti/p/%40ewi5746g"
                onClick={() => {
                  ReactGA.event({
                    category: 'Line',
                    action: 'Clicked Line Button',
                  });
                }}
                target="_blank"
              >
                後でLINEから応募
              </a>
            </p>
            <p className="column">
              <a
                className="button is-primary is-fullwidth is-medium has-text-weight-bold is-size-6-mobile"
                href={props.href}
                target="_blank"
              >
                いますぐ応募！！
              </a>
            </p>
          </div>
        </div>
      </div>
    </Root>
  );
}
